<template>
<!--  -->
<div class="fc">
  <hamitop-bar :dataHeader="responseData.topBar"></hamitop-bar>
  <topbar-base ></topbar-base>
  <div class="pr wf hf mt-20">
    <transition name="left-side">
      <com-left
        :dataenergyTrend="responseData.energyTrend"
        :datamouthdataProfiling="responseData.mouthdataProfiling"
        :datataskType="responseData.taskType"
        :datataskTypeComput="responseData.taskTypeComput"
        :datacomputilityUse="responseData.computilityUse"
        :datacomputingUse="responseData.computingUse"
      />
    </transition>
    <com-center
      class="comCenter"
      :dataconstructBasicData="responseData.constructBasicData"
      :datagpuProportion="responseData.gpuProportion"
      :datagpuProportionComput="responseData.gpuProportionComput"
      :datadataCenter="responseData.dataCenter"
    />
    <transition name="right-side">
      <com-right
        :datamonitoringData="responseData.monitoringData"
        :datanetworkSecurity="responseData.networkSecurity"
        :datacontentMainNews="responseData.contentMainNews"
      />
    </transition>
  </div>
</div>
</template>

<script>
import screenAdjustMixin from '@/views/mixin/screenAdjustMixin'
import hamitopBar from './hamitop-bar'
import comLeft from './left'
import comCenter from './center'
import comRight from './right'
import API from "@/api/sascreen-api.js"
import topbarBase from "../components/topbar-base"

export default {
  name: 'enterprise-security',
  components: {
    topbarBase,
    hamitopBar,
    comLeft,
    comCenter,
    comRight
  },
  mixins: [ screenAdjustMixin ],
  data () {
    return {
      responseData: {
        topBar: {},
        energyTrend: [],
        computilityUse: {},
        taskType: [],
        taskTypeComput:[],
        computingUse: [],
        constructBasicData: [],
        gpuProportion: [],
        gpuProportionComput: [],
        dataCenter: [],
        monitoringData: [],
        networkSecurity: {},
        contentMainNews: [],
      },
    }
  },
  mounted () {
    this.viewIndex()
    setInterval(() => {
      // API.getMonitordata({module: 'hamiIndex', key:'allUsage'}).then(data => {
      //   this.responseData.allUsage = JSON.parse(data.data.data.allUsage);
      // })
    }, 10000)
  },
  methods: {
    viewIndex () {
      const keys=
        'topBar,energyTrend,computilityUse,taskType,taskTypeComput,computingUse,' +
        'constructBasicData,gpuProportion,gpuProportionComput,dataCenter,' +
        'monitoringData,networkSecurity,contentMainNews'
      API.getMonitordata({module: 'hamiIndex', key:keys}).then(data => {
        this.responseData = data.data.data
        // this.responseData.topBar = JSON.parse(this.responseData.topBar) // 顶部导航
        // this.responseData.energyTrend = JSON.parse(this.responseData.energyTrend) // 能源趋势
        // this.responseData.computilityUse = JSON.parse(this.responseData.computilityUse) // 算力使用情况
        // this.responseData.taskType = JSON.parse(this.responseData.taskType) // 算力任务类型-各类任务数
        // this.responseData.taskTypeComput = JSON.parse(this.responseData.taskTypeComput); // 算力任务类型-各类任务算力数
        // this.responseData.computingUse = JSON.parse(this.responseData.computingUse); // 算力消费行业
        //
        // this.responseData.constructBasicData = JSON.parse(this.responseData.constructBasicData) // 算力建设情况
        // this.responseData.gpuProportion = JSON.parse(this.responseData.gpuProportion) // 算力建设-GPU数量占比
        // this.responseData.gpuProportionComput = JSON.parse(this.responseData.gpuProportionComput) // 算力建设-GPU数量算力占比
        // this.responseData.dataCenter = JSON.parse(this.responseData.dataCenter) // 算力建设-各数据中心建设情况
        //
        // this.responseData.monitoringData = JSON.parse(this.responseData.monitoringData) // 动环监控
        // this.responseData.networkSecurity = JSON.parse(this.responseData.networkSecurity) // 网络安全
        // this.responseData.contentMainNews = JSON.parse(this.responseData.contentMainNews) //实时事件
      })
    }
  }
}
</script>
<style>
</style>
